<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_planet_building')
}

const isOnPlanetsSection = computed(() => {
  return route.path.startsWith('/planets')
})

const goToPlanets = () => {
  router.push('/planets')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/planet.webm"
  >
    <template #text>
      <p class="pb-2">
        Buildings are the backbone of your planetary infrastructure. Each building serves a specific purpose.
      </p>
      <p class="pb-2">
        You can construct mines to extract resources, factories to build ships faster, research labs to advance technology, defensive structures to protect your planets and much more.
      </p>
      <p class="pb-2">
        Buildings require production <GenericIcon type="production" /> and time to construct.
      </p>
      <p class="pb-2">
        Lets start building some infrastructure!
      </p>
    </template>

    <template #alerts>
      <Alert type="info" class="mb-2">
        <p class="pb-2">
          Click on the "Production" tab and then on the <GenericIcon type="production" /> button. A list will appear with available buildings.
          You can select multiple buildings to construct, they will be queued automatically and the planet will build them one after another.
        </p>
        Click on the same <GenericIcon type="production" /> button again to stop adding buildings to your queue. And you will be shown what your current production queue is and its progress.
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnPlanetsSection" @click="goToPlanets" class="mr-2">
        Goto Planets
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Got it!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>